const API_URL = process.env.NEXT_PUBLIC_API_URL || "";

export async function loadCurrentProduct(
  id: number,
  signal?: AbortSignal
): Promise<SearchResultItem | null> {
  const response = await fetch(`${API_URL}/api/v2/search/item/${id}`, {
    credentials: "include",
    cache: "no-store",
    signal,
  });

  if (!response.ok) return null;

  const data = await response.json();
  const item = Array.isArray(data?.data) ? data.data[0] : null;

  return item?.id === id ? item : null;
}
